function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FLAG_MAP, MOBILE_PHONE_METADATA, PHONE_METADATA, createInput } from '@ali/i18n-utils';
import { useControllableValue, useCreation } from 'ahooks';
import { Input as _Input } from 'antd';
import classNames from 'classnames';
import once from 'lodash/once';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import { forwardRef } from "react";
import { CountrySelect } from "./country-select";
import { DEFAULT_COUNTRIES } from "./default-props";
import "./index.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var onRef = useCreation(function () {
    return once(function (e) {
      var inputEl = e === null || e === void 0 ? void 0 : e.input;
      if (inputEl && typeof ref === 'function') {
        ref(inputEl);
      }
    });
  }, []);
  return /*#__PURE__*/_jsx(_Input, _objectSpread(_objectSpread({}, props), {}, {
    ref: onRef
  }));
});
export var createPhoneInput = function createPhoneInput(metadata) {
  var PhoneInput = createInput(metadata);
  return Object.assign(function (props) {
    var divProps = pickBy(props, function (value, key) {
      return key.startsWith('data-');
    });
    var _props$countryOptions = props.countryOptions,
      countryOptions = _props$countryOptions === void 0 ? DEFAULT_COUNTRIES : _props$countryOptions;
    var _useControllableValue = useControllableValue(props, {
        defaultValue: undefined
      }),
      _useControllableValue2 = _slicedToArray(_useControllableValue, 2),
      value = _useControllableValue2[0],
      _setValue = _useControllableValue2[1];
    var nextProps = pick(props, 'country', 'international');
    var inputProps = pick(props, 'status', 'size', 'disabled', 'placeholder');
    var valueParsed = useCreation(function () {
      return PhoneInput.parsePhoneNumber(value !== null && value !== void 0 ? value : '');
    }, [value]);
    var setValue = function setValue(value) {
      console.log(value);
      _setValue(value);
    };
    var isFixedCountry = !!props.country;
    var _useControllableValue3 = useControllableValue(props, {
        valuePropName: 'country',
        defaultValuePropName: 'defaultCountry',
        trigger: 'onCountryChange',
        defaultValue: countryOptions[0]
      }),
      _useControllableValue4 = _slicedToArray(_useControllableValue3, 2),
      userSelectedCountry = _useControllableValue4[0],
      setCountry = _useControllableValue4[1];
    var currentCountry = useCreation(function () {
      var _valueParsed$country;
      return (_valueParsed$country = valueParsed === null || valueParsed === void 0 ? void 0 : valueParsed.country) !== null && _valueParsed$country !== void 0 ? _valueParsed$country : userSelectedCountry;
    }, [valueParsed === null || valueParsed === void 0 ? void 0 : valueParsed.country, userSelectedCountry]);
    return /*#__PURE__*/_jsx(PhoneInput, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, divProps), {}, {
      international: true
    }, nextProps), inputProps), {}, {
      style: props.style,
      className: classNames('i18n-phone-input', props.className),
      value: value,
      onChange: setValue,
      country: userSelectedCountry
    }, isFixedCountry ? {
      // withCountryCallingCode: true,
      prefix: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("img", {
          className: "i18n-phone-flag",
          alt: currentCountry,
          src: FLAG_MAP[currentCountry]
        }), /*#__PURE__*/_jsxs("span", {
          children: ["+", PhoneInput.getCountryCallingCode(userSelectedCountry)]
        })]
      })
    } : {}), {}, {
      addonBefore: isFixedCountry ? null : /*#__PURE__*/_jsx(CountrySelect, _objectSpread(_objectSpread({
        counties: countryOptions,
        value: currentCountry
      }, inputProps), {}, {
        onChange: function onChange(countryCode) {
          var callingCode = PhoneInput.getCountryCallingCode(countryCode);
          if (!callingCode) return;
          setCountry(countryCode);
          if (!valueParsed) {
            return;
          }
          setValue(value.replace(new RegExp("^\\+".concat(valueParsed.countryCallingCode)), "+".concat(callingCode)));
        }
      })),
      inputComponent: Input
    }));
  }, PhoneInput);
};
export var I18nMobileInput = /*#__PURE__*/createPhoneInput(MOBILE_PHONE_METADATA);
export var I18nPhoneInput = /*#__PURE__*/createPhoneInput(PHONE_METADATA);